import { useState } from "react";
import React from "react";

const backendUrl = process.env.REACT_APP_BE_URL || 'http://localhost:8080';

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [feedbackSubmissionStatus, setFeedbackSubmissionStatus] = useState(undefined);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);
    if (name.trim() === '' || email.trim() === '' || message.trim() === '') {
      setFeedbackSubmissionStatus({color: 'maroon', message: 'Please ensure you enter your name, email and feedback'});
      return;
    }
    fetch(`${backendUrl}/feedback`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({name, email, feedbackText: message})
    }).then((res) => {
      if (res.status !== 201) throw new Error(`Response status from POST /feedback is ${res.status}. Expected: 201`);
      console.log('resss recd, setting feedback sub status')
      setFeedbackSubmissionStatus({color: 'darkgreen', message: <b>Thank you. Your feedback was successfully submitted</b>})
      clearState();
    }).catch((err) => {
      setFeedbackSubmissionStatus({color: 'maroon', message: <span>OOPS! something went wrong in submitting feedback.<br/> While we fix this, please email your feedback to us</span>})
      console.error(err)
    })
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Got a Minute?<br/>Tell Us What You Think!</h2>
                <p>
                  Your thoughts matter!<br/>
                  Please share your experience<br/>
                  We'd love to get your perspective on how the tool felt to use—any feedback is super helpful
                  {/* Please fill out the form below to send us an email and we will
                  get back to you as soon as possible. */}
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                        value={name}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                        value={email}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Feedback"
                    required
                    onChange={handleChange}
                    value={message}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                {
                  feedbackSubmissionStatus ?
                  <div id="feedbackSubmissionStatus" style={{color: feedbackSubmissionStatus.color}}>{feedbackSubmissionStatus.message}</div>
                  : <></>
                }
                <button type="submit" className="btn btn-custom btn-lg">
                  Submit Feedback
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              {/* <p>
                <span>
                  <i className="fa fa-map-marker"></i> LinkedIn
                </span>
                {props.data ? props.data.linkedin1 : "loading"} <br/>
                {props.data ? props.data.linkedin2 : "loading"}
              </p> */}
            </div>
            {/* <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div> */}
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email1 : "loading"} <br/>
                {props.data ? props.data.email2 : "loading"}
              </p>
            </div>
          </div>
          <div className="col-md-12">
          </div>
        </div>
      </div>
    </div>
  );
};
